export default {
    Interview: {
        alertStartMsg: "面試尚未開始,請耐心等待",
        alertEndMsg: "面試已結束",
    },
    Login: {
        login: "登入",
        loginPlaceholder: "登入ID",
        detectionTips: "登入前,請先進行",
        detectionButton: "設備檢測",
        loginWarningMsg: "登入ID不能為空",
        loginFailMsg: "登入ID有誤或登入連結有誤,請重試",
        getLoginDataFailMsg: "登入連結有誤,請重試",
    },
    Message: {
        title: "身份核對",
        name: "姓名",
        gender: "性別",
        time: "面試時間",
        tips: "點擊進入面試間後,面試官將能看到你的狀態,請稍作等待,面試官會稍後進入面試間",
        btnStatus: ["尚未開始,請等待", "分鐘後開始", "秒", "進入面試間", "面試已結束"],
        enterStartAlert: "面試尚未開始,請耐心等待",
        enterEndAlert: "面試已結束",
    },
};
